import http from "@/http";

// ### 菜单列表
export const getMenuList = {
  p: "/api/menu/list_tree",
  r: data => {
    return http({
      url: "/api/menu/list_tree",
      method: "get",
      data
    });
  }
};
// ### 格式化菜单列表
// http://base.leubao.com/api/menu/handle_tree
export const getMenuHandleTree = {
  p: "/api/menu/handle_tree",
  r: data => {
    return http({
      url: "/api/menu/handle_tree",
      method: "get"
    });
  }
};
// ### 根据id获取详情
// export const getTreeList = data => {
//   return http({
//     url: "/v1/menu/index",
//     method: "get",
//     data
//   });
// };

// ### 根据id进行删除
export const deleteMenu = {
  p: "/api/menu/delete",
  r: data => {
    return http({
      url: "/api/menu/delete",
      method: "post",
      data
    });
  }
};

// ### 编辑菜单

// https://api.msg.alizhiyou.cn/v1/menu/edit
export const updataMenu = {
  p: "/api/menu/edit",
  r: data => {
    return http({
      url: "/api/menu/edit",
      method: "post",
      data
    });
  }
};

// 添加菜单
// https://api.msg.alizhiyou.cn/v1/menu/add
export const addMenu = {
  p: "/api/menu/add",
  r: data => {
    return http({
      url: "/api/menu/add",
      method: "post",
      data
    });
  }
};
